import { render } from "./InvoiceReceiverForm.vue?vue&type=template&id=8a7e3990"
import script from "./InvoiceReceiverForm.vue?vue&type=script&lang=js"
export * from "./InvoiceReceiverForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__